<template>
  <div class="col-12 col-lg-6">
    <div class="card shadow-sm">
      <div class="card-body px-2">
        <form
          id="shoot"
          method="POST"
          :action="url"
          class="w-100"
          @submit.prevent="onSubmit"
        >
          <div class="d-flex">
            <div class="flex-width">
              <div class="form-group">
                <!-- <input required  class="form-control text-center text-lg" :value="shootValue" type="tel" maxlength="5" min="5" id="shootNumber" placeholder="กรอกเลข 5 หลัก"> -->
                <input
                  v-model="shootValue"
                  pattern="\d{5,5}"
                  required="required"
                  name="shoot"
                  class="form-control text-center text-lg disabled"
                  type="tel"
                  placeholder="กรอกเลข 5 หลัก"
                  maxlength="5"
                  min="5"
                  @keypress="validateNumber($event)"
                  @paste="onPaste($event)"
                >
              </div>
            </div>
          </div>
          <div class="d-flex">
            <div class="flex-width my-1">
              <button
                type="button"
                class="btn btn-yellow w-100"
                @click="digitClick(1)"
              >
                1
              </button>
            </div>
            <div class="flex-width mx-1 my-1">
              <button
                type="button"
                class="btn btn-yellow w-100"
                @click="digitClick(2)"
              >
                2
              </button>
            </div>
            <div class="flex-width my-1">
              <button
                type="button"
                class="btn btn-yellow w-100"
                @click="digitClick(3)"
              >
                3
              </button>
            </div>
          </div>
          <div class="d-flex">
            <div class="flex-width my-1">
              <button
                type="button"
                class="btn btn-yellow w-100"
                @click="digitClick(4)"
              >
                4
              </button>
            </div>
            <div class="flex-width mx-1 my-1">
              <button
                type="button"
                class="btn btn-yellow w-100"
                @click="digitClick(5)"
              >
                5
              </button>
            </div>
            <div class="flex-width my-1">
              <button
                type="button"
                class="btn btn-yellow w-100"
                @click="digitClick(6)"
              >
                6
              </button>
            </div>
          </div>
          <div class="d-flex">
            <div class="flex-width my-1">
              <button
                type="button"
                class="btn btn-yellow w-100"
                @click="digitClick(7)"
              >
                7
              </button>
            </div>
            <div class="flex-width mx-1 my-1">
              <button
                type="button"
                class="btn btn-yellow w-100"
                @click="digitClick(8)"
              >
                8
              </button>
            </div>
            <div class="flex-width my-1">
              <button
                type="button"
                class="btn btn-yellow w-100"
                @click="digitClick(9)"
              >
                9
              </button>
            </div>
          </div>
          <div class="d-flex">
            <div class="flex-width my-1">
              <button
                type="reset"
                class="btn btn-dark w-100"
                @click="digitClear()"
              >
                ลบ
              </button>
            </div>
            <div class="flex-width mx-1 my-1">
              <button
                type="button"
                class="btn btn-yellow w-100"
                @click="digitClick(0)"
              >
                0
              </button>
            </div>
            <div class="flex-width my-1">
              <button
                type="button"
                class="btn btn-dark w-100"
                @click="digitRandom()"
              >
                สุ่มเลข
              </button>
            </div>
          </div>
          <div class="d-flex">
            <div class="flex-width my-1">
              <button
                type="submit"
                class="btn btn-outline-primary w-100"
              >
                {{ formattedTimeLeft }}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
const SECOND = 1;
const MINUTE = 60 * SECOND;
export default {
  name: 'Shoot',
  props: {
    url: { type: String, default: '' },
    gameId: { type: Number, default: '' },
    userId: { type: Number, default: '' },
  },

  data() {
    return {
      shootValue: '',
      totalSeconds: 0,
      timerInterval: null,
      // buttonItemClass:'btn w-100 btn-outline-dark',
      // isActive: false
    };
  },
  computed: {
    formattedTimeLeft() {
      return this.totalSeconds > 0
        ? `ยิงเลขได้ใน ${
          Math.floor((this.totalSeconds % MINUTE) / SECOND)
            .toString()
            .padStart(2, '0')}`
        : 'ยิงเลข';
    },
  },

  watch: {
    formattedTimeLeft(val) {
      if (this.totalSeconds <= 0) {
        this.onTimesUp();
      }
    },
  },
  methods: {
    digitClick(value) {
      if (this.shootValue.length < 5) {
        this.shootValue += value;
      }
    },
    digitClear() {
      this.shootValue = '';
    },
    digitRandom() {
      this.shootValue = Math.floor(Math.random() * 90000) + 10000;
    },
    onSubmit(e) {
      if (this.totalSeconds <= 0) {
        self = this;
        const messageShoot = `ยิงเลข ${this.shootValue} สำเร็จ`;



        if (this.shootValue.toString().length == 5) {
          axios
            .post(this.url, { digit: this.shootValue, game_id: this.gameId })
            .then((response) => {
              if (response.status == 200) {
                self.digitClear();
                self.startCountdown();
                self.digitClear();
                Vue.$toast.open({
                  message: messageShoot,
                  type: 'success',
                  duration: 5000,
                  position: 'top-right',
                });
              }
            })
            .catch((error) => {
              if (error.response.status == 406) {
                Vue.$toast.open({
                  message: 'จบเกมส์',
                  type: 'error',
                  duration: 5000,
                  position: 'top-right',
                });
              } else {
                Vue.$toast.open({
                  message: 'ลองใหม่ภายหลัง',
                  type: 'error',
                  duration: 5000,
                  position: 'top-right',
                });
              }
            });
        } else {
          Vue.$toast.open({
            message: 'ระบุเลขยิง 5 ตัว',
            type: 'error',
            duration: 1000,
            position: 'top-right',
            dismissible: true,
          });
        }
      }
    },
    onTimesUp() {
      clearInterval(this.timerInterval);
      this.totalSeconds = 0;
    },
    startCountdown() {
      this.totalSeconds = 10;
      this.timerInterval = setInterval(() => (this.totalSeconds -= 1), 1000);
    },
    onPaste(evt) {
      evt.preventDefault();
    },
    validateNumber(evt) {
      evt = evt || window.event;
      const charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31
        && (charCode < 48 || charCode > 57)
        && charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
  },
};
</script>
